import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  SimpleGrid,
  Button,
  useTheme,
} from "@chakra-ui/react";
import TemplatePreview from "./TemplatePreview";

const TemplatesModal = ({
                          isOpen,
                          onClose,
                          categories,
                          campaignCategory,
                          templates,
                          selectedTemplate,
                          handleTemplateSelect,
                          customizeTemplate,
                          setIsConfigVisible,
                          onTemplatesModalClose,
                          saveEmailTemplate
                        }) => {
  const theme = useTheme();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          Templates for{" "}
          {categories.find((c) => c.id === campaignCategory)?.name}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody style={{ maxHeight: "600px", overflowY: "auto" }}>
          <SimpleGrid columns={4} spacing={2}>
            {templates.map((template) => (
              <TemplatePreview
                key={template.id}
                template={template}
                selectedTemplate={selectedTemplate}
                handleTemplateSelect={handleTemplateSelect}
              />
            ))}
          </SimpleGrid>
        </ModalBody>
        <ModalFooter>
          <Button
            color={theme.colors.ghost}
            variant="ghost"
            onClick={customizeTemplate}
            isDisabled={!selectedTemplate}
          >
            Customize
          </Button>
          <Button
            marginLeft="10px"
            colorScheme="blue"
            mr={3}
            onClick={async () => {
              await saveEmailTemplate(JSON.stringify(selectedTemplate.content), selectedTemplate.html)
              setIsConfigVisible(true);
              onTemplatesModalClose();
            }}
            isDisabled={!selectedTemplate}
          >
            Select
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TemplatesModal;
